// components/ColorLabeledStatList.tsx
import React from "react"




const ColorLabeledStatList = ({
    title,
    items =[],
    titleClassName = "text-sm font-semibold text-blue-700",
    valueBgClass = "bg-gray-100",
    align = "left",
}) => {
    const alignClass = {
        left: "text-left",
        center: "text-center",
        right: "text-right",
    }[align]

    return (
        <div className="space-y-2">
            {title && <div className={`${titleClassName}  pb-1`}>{title}</div>}
            <div className="space-y-2">
                {items.map((item, index) => (
                    <div key={index} className={`flex items-center justify-between ${alignClass}`}>
                        <div className="flex items-center gap-2">
                            <div className={`w-2 h-2 rounded-full ${item?.colorClass}`} />
                            <span className="text-sm text-gray-800">{item?.label}</span>
                        </div>
                        <span
                            className={`text-sm font-semibold rounded px-2 py-0.5 ${valueBgClass} text-gray-700`}
                        >
                            {item?.value}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default ColorLabeledStatList